import type {
  EditorBlock,
  EditorContent,
} from "../../services/newsService/newsService.types";

const normalizeChecklistItem = (item: any): Record<string, any> => {
  if (typeof item === "string") {
    return {
      content: item,
      meta: { checked: false },
      items: [],
    };
  }

  const source = item && typeof item === "object" ? item : {};
  const sourceMeta = source.meta && typeof source.meta === "object" ? source.meta : {};
  const {
    content,
    text,
    checked,
    meta: _meta,
    items: _items,
    ...rest
  } = source;

  return {
    ...rest,
    content: content ?? text ?? "",
    meta: {
      ...sourceMeta,
      checked: Boolean(sourceMeta.checked ?? checked),
    },
    items: Array.isArray(source.items)
      ? source.items.map(normalizeChecklistItem)
      : [],
  };
};

export const normalizeNewsEditorContent = (content: EditorContent): EditorContent => {
  let changed = false;

  const blocks = (content.blocks || []).map((block): EditorBlock => {
    if (block.type !== "checklist") return block;

    changed = true;
    const data = block.data || {};

    return {
      ...block,
      type: "list",
      data: {
        ...data,
        style: "checklist",
        meta: data.meta && typeof data.meta === "object" ? data.meta : {},
        items: Array.isArray(data.items)
          ? data.items.map(normalizeChecklistItem)
          : [],
      },
    };
  });

  return changed ? { ...content, blocks } : content;
};
